var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 598,
    viewBox: "0 0 621 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563.722 577.662C437.759 674.679 120.909 535.746 41.6009 432.774C-37.7076 329.803 0.113165 167.681 126.076 70.6643C252.039 -26.3524 418.444 -21.5253 497.753 81.4459C577.061 184.417 689.685 480.645 563.722 577.662Z",
    fill: "url(#paint0_radial_267_1155)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_267_1155",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211 110) rotate(58.5645) scale(916.52 727.422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260412,
    stopColor: "#030611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620775,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeShadow);
export default __webpack_public_path__ + "static/media/globe-shadow.d41856cb85c19b0ce0c2871b0a470fc2.svg";
export { ForwardRef as ReactComponent };